<template>
    <div class="w-full min-h-[60vh] largeDesktop:min-h-[80vh] planPage">
        <div v-if="product.length > 0"
            class="myHappyHomeLandingPage relative border-1 rounded-[20px] min-w-full p-[5px] tablet:px-[20px] pt-[30px] laptop:pt-[20px] !pb-[40px] bg-opacity-50 bg-[#fff] border-[#CCCCCC]">
            <div v-if="$helper.isSSOLoggedIn" class="absolute -top-[18px] left-2.5 z-10">
                <button @click="SSOButtonClicked"
                    class="transform lg:hover:scale-[1.15] active:scale-[0.98] mobile:flex laptop:hidden justify-center items-center w-[35px] h-[35px] rounded-full bg-customYellow-100 focus:outline-none text-white transition-transform duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]">
                    <img src="../../assets/images/arrow-icon.png" alt="Toggle Icon"
                        class="rotate-[180deg] min-h-[22px] min-w-[22px] max-h-[22px] max-w-[22px] transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]">
                </button>
            </div>
            <div @click="cartModal()"
                class="p-[5px] pr-[10px] rounded-full mobile:flex laptop:hidden items-center shadow-[0_0_10px_0_#00000026] gap-[10px] w-max bg-[#fff] cursor-pointer absolute -top-[20px] mobile:right-[10px] tablet:right-[20px] laptop:right-[10px]"
                :class="{ '!cursor-not-allowed': cartCountResponse == null || !(cartCountResponse['items_count'] ?? 0 > 0) }">
                <p class="m-0 rounded-[50px] !py-[2px] !px-[10px] flex items-center w-max gap-[7px] bg-[#F5B134]"
                    :class="{ '!bg-[#CCCCCC]': cartCountResponse == null || !(cartCountResponse['items_count'] ?? 0 > 0) }">
                    <img src="../../assets/images/cart-check-white.png" alt="" class="w-[22px] h-[22px]">
                    <span class="font-poppins font-medium text-[18px] text-[#fff]">{{
                        !(cartCountResponse['items_count']
                            ?? 0 > 0) ? 0 : cartCountResponse?.items_count || 0 }}</span>
                </p>
                <p class="0 font-poppins text-[20px] font-medium text-[#333333]"
                    :class="{ '!text-[#CCCCCC]': cartCountResponse == null || !(cartCountResponse['items_count'] ?? 0 > 0) }">
                    ${{
                        $helper.formatAmount(!(cartCountResponse['items_count'] ?? 0 > 0) ? 0 :
                            cartCountResponse?.total_amount || 0)
                    }}</p>
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-2 justify-center gap-[15px] desktop:gap-[30px] w-full">
                <div v-for="(item, index) in product" :key="index"
                    :class="item.is_maintenance === 1 ? 'flex flex-col justify-between' : ''">
                    <div class="bg-[#fff] rounded-[20px] p-[10px] shadow-[0px_0px_10px_0px_#00000026] relative">
                        <div
                            class="flex laptop:flex-row flex-col items-start laptop:items-center justify-between gap-[10px] p-[15px] rounded-[15px] min-h-[80px] text-left bg-[#2459A8]">
                            <h2
                                class="m-0 text-[20px] tablet:text-[20px] laptop:text-[17px] largeDesktop:text-[22px] mb-1.5 font-normal font-days text-left text-[#fff]">
                                {{ item.bundle_name }}</h2>
                            <div
                                class="w-full tablet:w-1/2 laptop:w-1/3 min-w-max flex items-center mobile:justify-start laptop:justify-end">
                                <div class="text-left w-max">
                                    <h6
                                        class="hidden mb-[5px] text-[16px] laptop:text-[14px] desktop:text-[16px] font-semibold font-poppins text-customYellow-100">
                                        Monthly</h6>
                                    <h2
                                        class="m-0 text-[20px] tablet:text-[25px] laptop:text-[22px] desktop:text-[25px] font-bold font-poppins text-[#fff]">
                                        ${{ $helper.formatAmount(item.amount) }}<span class="text-[16px]">/mo</span>
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col px-2.5">
                            <p v-if="item.description.length > 0"
                                class="!mt-0 py-[15px] font-poppins text-[12px] lg:text-[14px] text-[#000] text-justify leading-tight border-b border-[#E5D2B4]">
                                {{ item.description }}</p>
                            <addons :addons="getAddonData(item.plans)" :addonsInfoIcon="item.is_maintenance == 0" />
                        </div>

                        <div
                            class="pt-[30px] pb-[20px] px-2.5 flex justify-center items-center gap-2.5 laptop:gap-[5px] desktop:gap-2.5 tablet:gap-4">
                            <span v-if="item.quantity == 0" @click="updateCounter('increment', item)"
                                :class="item.is_maintenance == 0 ? '' : 'mx-auto '"
                                class="CustomYellowBtn group w-[150px] desktop:w-[160px] h-[40px] flex justify-center items-center gap-1 font-poppins font-medium text-[12px] tablet:text-[14px] rounded-full cursor-pointer ">
                                <img src="../../assets/images/cart-check-white.png"
                                    class="w-[22px] h-[22px] object-contain" alt="icon">
                                Select this plan
                            </span>
                            <div v-else class="flex justify-center items-center gap-4">
                                <quantityCounter v-if="item.is_show_quantity == 1" :quantity="item.quantity"
                                    :product="item" @update-counter="updateCounter" />
                                <button v-else type="button" @click="updateCounter('remove', item)"
                                    class="transform lg:hover:scale-[1.15] active:scale-[0.98] duration-300 group !h-10 !w-10 flex items-center justify-center rounded-full focus:outline-0 transition-all border-1 border-orange-100 !bg-transparent hover:!bg-orange-100">
                                    <img src="../../assets/images/trash-icon-updated.png" alt="Cart Icon"
                                        class="!w-7 !h-7 group-hover:hidden">
                                    <img src="../../assets/images/trash-icon-white-updated.png" alt="Cart Icon"
                                        class="!w-7 !h-7 hidden group-hover:!block">
                                </button>
                                <img src="../../assets/images/cart-icon-with-bg.svg" alt="Cart Icon"
                                    class="!w-10 !h-10">
                            </div>
                            <span v-if="item.is_maintenance == 0" @click="openCoverageModal()"
                                class="CustomBlueBtn w-[200px] tablet:w-[250px] laptop:w-[220px] desktop:w-[250px] h-[40px] flex justify-center items-center gap-1 font-poppins font-medium text-[12px] tablet:text-[14px] rounded-full cursor-pointer">
                                Review Coverage Amount
                            </span>
                        </div>
                    </div>
                    <div v-if="item.is_maintenance === 1"
                     class="hidden lg:block w-[370px] xl:w-[380px] largeDesktop:w-[430px] mx-auto relative">

                        <div class="relative z-[2] transform transition-transform duration-[500ms] hover:scale-[1.02]">
                            <img src="../../assets/images/truck-img.png"
                                class="animate-floatRotate h-full w-full object-contain" alt="img"></div><img
                            src="../../assets/images/truck-circle.png"
                            class="h-full w-[82%] xl:w-[83%] largeDesktop:w-[85%] object-contain absolute -right-[20px] -top-[20px] xl:-right-[20px] xl:-top-[20px] largeDesktop:-right-[30px] largeDesktop:-top-[30px] z-0"
                            alt="img">
                    </div>
                </div>
            </div>
            <button v-if="cartCountResponse['items_count'] ?? 0 > 0" @click="continueClicked"
                :disabled="!(cartCountResponse['items_count'] ?? 0 > 0)"
                class="CustomYellowBtn z-40 absolute cursor-pointer mobile:w-max -bottom-5 translate-x-1/2 tablet:translate-x-[unset] right-[50%] tablet:right-[20px] text-[14px] font-poppins font-medium rounded-full py-[9px] px-[18px]">Continue
                to Checkout</button>
        </div>
    </div>

    <!-- Addons Modal -->
    <addonsModal ref="addonsModalRef" :callbacks="handleLoginCallback" />
    <!-- Cart Modal -->
    <bundleCartModal ref="bundleCartModalRef" @close-cart-modal="cartmodalOpen = false"
        :continueClicked="continueClicked" :updateCart="updateCart" :openCoverageModal="openCoverageModal" />

    <!-- coverage Modal -->
    <coverageModal ref="coverageModalRef" :cartmodal-open="cartmodalOpen" />
    <!-- planDetailModal -->
    <div class="modal fade bg-[#00000063]" ref="planDetailModal" id="planDetailModal" tabindex="-1" aria-labelledby="planDetailModal"
        aria-hidden="true">
        <div
            class="modal-dialog modal-dialog-centered mobile:!px-3 tablet:!px-0 mobile:!min-w-full mobile:!max-w-full tablet:!w-[500px] tablet:!min-w-[500px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
            <div class="modal-content">
                <div class="modal-body !p-3 !pb-5">
                    <div class="relative">
                        <button type="button"
                            class="absolute top-3 right-[10px] w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
                            data-bs-dismiss="modal" aria-label="Close">
                            <img src="../../assets/images/modal-cross-icon.svg" alt="Cross Icon"
                                class="w-[30px] h-[30px] object-contain">
                        </button>
                        <div
                            class="rounded-lg overflow-hidden h-[80px] bg-customBlue-100 flex flex-col justify-center gap-1 p-3 w-full">
                            <span
                                class="text-[13px] font-poppins font-normal m-0 rounded-full w-max px-[15px] block bg-customYellow-100 text-white">{{
                                    addonPlanDetails?.trade_name ?? '' }}</span>
                            <h4 class="text-[20px] font-medium font-poppins m-0 text-white">{{
                                addonPlanDetails?.plan_name ?? '' }}</h4>
                        </div>
                    </div>
                    <div ref="scrollBox" class="max-h-[550px] overflow-y-auto customScrollbar px-2.5 mt-[25px] py-1">
                        <!-- <customAccordion :items="getCoveredData()" /> -->
                        <div v-if="!$helper.isEmpty($helper.getCleanText(addonPlanDetails?.covered))"
                            class="shadow-[0px_0px_10px_0px_#00000026] p-[15px] !rounded-[10px] overflow-hidden">
                            <h4
                                class="w-full text-[16px] font-medium font-poppins mb-2.5 text-left bg-transparent !text-customBlue-100">
                                Included:</h4>
                            <div v-html="addonPlanDetails?.covered" class="bundleDescription">
                            </div>
                        </div>
                        <div v-if="!$helper.isEmpty($helper.getCleanText(addonPlanDetails?.not_covered))"
                            class="shadow-[0px_0px_10px_0px_#00000026] p-[15px] !rounded-[10px] overflow-hidden mt-3">
                            <h4
                                class="w-full text-[16px] font-poppins mb-1.5 text-left bg-transparent !text-customBlue-100">
                                Excluded:</h4>
                            <div v-html="addonPlanDetails?.not_covered" class="bundleDescription excludedItems">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <authComponent v-if="!$helper.isLoggedIn()" ref="authModal" :callbacks="handleCallback" />

</template>

<script>

import { Modal } from "bootstrap";
import { data } from 'jquery';
import addons from '../../components/nest_components/addons/addons.vue';
import addonsModal from '../../components/nest_components/addons/addons_modal.vue';
import bundleCartModal from '../../components/nest_components/addons/bundle_cart_modal.vue';
import { mapActions, mapGetters } from "vuex";
import quantityCounter from '../../components/partialComponent/quantityCounter.vue';
import 'vue3-carousel/dist/carousel.css';
import authComponent from "../../components/authComponent/authComponent.vue";
import coverageModal from "../../components/nest_components/coverage/coverage_modal.vue";
export default {
    components: {
        addons,
        addonsModal,
        quantityCounter,
        bundleCartModal,
        authComponent,
        coverageModal
    },
    computed: {
        ...mapGetters([
            "selectedProtectionPlan",
            "protectionPlanBundle",
            "cartValidate",
            "removeProtectionCartData",
            "cartUpdated",
            "cartCountResponse",
            "addonPlanDetails",
            "cartModalState",
            "sidebarCollapsedState"
        ]),
    },

    watch: {


        selectedProtectionPlan: function (data) {
            this.getBundleData()
        },

        protectionPlanBundle: function (data) {
            if (data.length > 0)
                this.product = data
        },

        removeProtectionCartData: function (data) {
            if (this.$refs.bundleCartModalRef) {
                this.cartmodalOpen = false
                this.$refs.bundleCartModalRef.closeModal()
            }
            this.getCartCount({})
            // this.upsertCart({
            //     "bundle_id": this.selectedProduct.id,
            //     "quantity": this.selectedProduct.quantity,
            //     "partner_id": this.selectedProduct.partner_id
            // })

        },
        cartValidate: function (data) {

            if (this.cartValidate.validation_passed) {

                this.upsertCart({
                    "bundle_id": this.selectedProduct.id,
                    "quantity": this.selectedProduct.quantity,
                    "partner_id": this.selectedProduct.partner_id
                })

            }
            else {

                // this.$confirmDialog.show({
                //     title: "Action Required",
                //     message: this.cartValidate.message,

                //     onConfirm: () => {
                //         this.removeBundle(this.cartValidate)
                //     },
                // });
            }

        },

        cartUpdated: function (data) {

            this.isLoading = true
            this.getBundleData()
            this.getCartCount({})
            // this.$refs.addonsModalRef.openModal();

        },

        cartCountResponse: function (data) {
            if (this.cartCountResponse.has_repair == false && (this.cartCountResponse.item_ids ?? []).length > 0) {
                this.removeProtectionItemCart({
                    "item_ids": this.cartCountResponse.item_ids ?? [],
                })
            }
        },

        addonPlanDetails: function (data) {

            const modalEl = this.$refs.planDetailModal;
            if (this.modal) return
            // Create bootstrap modal
            this.modal = new Modal(modalEl, { backdrop: 'static' });
            document.documentElement.style.overflow = 'hidden';
            this.adjustPlanModalHeight();
            window.addEventListener('resize', this.adjustPlanModalHeight);
            window.addEventListener('orientationchange', this.adjustPlanModalHeight);
            // Fix scroll restore on close
            modalEl.addEventListener("hidden.bs.modal", () => {
                document.documentElement.classList.remove("overflow-hidden");
                document.documentElement.style.overflow = '';
                this.modal = null
                window.addEventListener('resize', this.adjustPlanModalHeight);
                window.addEventListener('orientationchange', this.adjustPlanModalHeight);
            });

            modalEl.addEventListener("shown.bs.modal", () => {
                if (this.$refs.scrollBox) {
                    this.$refs.scrollBox.scrollTo({ top: 0, behavior: "smooth" });
                }
            });
            this.modal.show();
        },

        cartModalState: function (data) {
            if (data) {
                this.updateCartModalState(false)
                this.cartModal()
            }
        }
    },

    data() {
        return {
            isLoading: true,
            product: [],
            selectedProduct: null,
            cartmodalOpen: false,
        };
    },


    mounted() {
        this.initMountApis()
    },
    methods: {

        ...mapActions([
            "getProtectionPlansBundle",
            "validateCart",
            "removeProtectionItemCart",
            "upsertCart",
            "getCartCount",
            "getSideMenu",
            "updateCartModalState"
        ]),

        initMountApis() {
            this.getCartCount({})
            this.getBundleData()
        },


        removeBundle(data) {
            this.removeProtectionItemCart({
                "bundle_ids": data.bundle_ids,
                "plan_ids": data.plan_ids,
            })
        },

        cartModal() {
            if (this.cartCountResponse == null || !(this.cartCountResponse['items_count'] ?? 0 > 0)) return
            this.cartmodalOpen = true
            this.$refs.bundleCartModalRef.openModal()
        },

        getAddonData(data) {
            const groupedData = data.reduce((acc, item) => {
                const key = item.trade_name;
                if (!acc[key]) {
                    acc[key] = [];
                }
                acc[key].push(item);
                return acc;
            }, {});
            return groupedData
        },
        continueClicked() {

            if (this.cartCountResponse.has_repair == false) {
                if (this.$helper.isSSOLoggedIn()) {
                    document.documentElement.classList.remove("overflow-hidden");
                    this.modal = null
                    this.$router.replace({
                        name: 'partnerCheckout'
                    })
                } else if (this.$helper.isLoggedIn()) {
                    document.documentElement.classList.remove("overflow-hidden");
                    this.modal = null
                    this.$router.push({
                        name: 'partnerCheckout'
                    })
                } else {
                    this.$refs.authModal.openModal();
                }

            } else {
                this.$refs.addonsModalRef.openModal();
            }
        },

        getBundleData() {
            if (this.isLoading) {
                this.isLoading = false
                this.getProtectionPlansBundle({ "route_slug": "bundle" });
            }
        },

        openCoverageModal() {
            this.$refs.coverageModalRef.openModal()
        },

        updateCounter(option, item) {
            let quantity = JSON.parse(JSON.stringify(item.quantity))
            if (option == "increment") {
                quantity++
            } else if (option == "decrement" || option == "remove") {
                if (quantity > 1) {
                    quantity--
                } else {
                    quantity = 0
                }
            } else {
                quantity = 0
            }

            this.cartUpdatePopup(option, item, quantity)

        },

        cartUpdatePopup(option, item, quantity) {
            if (quantity > 0) {
                this.updateCart(option, {
                    id: item.id,
                    quantity: quantity,
                    partner_id: item.partner_id,
                    type: 'bundle'
                })
                document.documentElement.scrollTo({ top: 0, behavior: "smooth" });
            }
            else {
                this.$dialog.show({
                    title: "Delete Item",
                    text: 'Are you sure you want to delete this item?',
                    // html: `
                    // <div class="flex flex-col items-center justify-center gap-4 text-gray-700 text-[16px]">
                    //     <img src=${require('../../assets/images/delete-icon-with-bg.png')} style="width:60px; height:auto;">
                    //     Are you sure you want to delete this item?
                    // </div>`,

                    onConfirm: () => {
                        this.updateCart(option, {
                            id: item.id,
                            quantity: quantity,
                            partner_id: item.partner_id,
                            type: 'bundle'
                        })
                        document.documentElement.scrollTo({ top: 0, behavior: "smooth" });
                    },
                });
            }

        },

        updateCart(option, plan, type = 'bundle', action = 'update') {
            this.selectedProduct = plan
            if (option == 'decrement' || option == 'remove') {
                this.upsertCart({
                    "bundle_id": plan.id,
                    "quantity": plan.quantity,
                    "partner_id": plan.partner_id
                })
            }
            else {
                this.validateCart({
                    "bundle_id": plan.id,
                    "quantity": plan.quantity,
                    "partner_id": plan.partner_id

                })
            }
        },

        adjustPlanModalHeight() {
            const modalContent = this.$refs.scrollBox;
            if (modalContent) {
                const vh = window.innerHeight;
                const vw = window.innerWidth;
                let maxHeight;
                if (vw < 300) {
                    maxHeight = vh * 0.5 - 40;
                } else if (vw < 768) {
                    maxHeight = vh * 0.8 - 50;
                } else if (vw < 991) {
                    maxHeight = vh * 0.8 - 50;
                } else if (vw < 1440) {
                    maxHeight = vh * 0.8 - 50;
                }
                else {
                    maxHeight = vh * 0.8 - 40;
                }
                modalContent.style.maxHeight = `${maxHeight}px`;
                modalContent.style.overflowY = 'auto';
            }
        },

        handleCallback(option) {
            if (option == "verified") {
                this.$refs.authModal.closeModal()
                this.getSideMenu({});
                if (this.$helper.isSSOLoggedIn()) {
                    this.$router.replace({
                        name: 'partnerCheckout'
                    })
                } else {
                    this.$router.push({
                        name: 'partnerCheckout'
                    })
                }

            }
        },

        handleLoginCallback(option) {
            if (option == "login") {
                setTimeout(() => {
                    this.$refs.authModal.openModal();
                }, 500);

            }
        },

        SSOButtonClicked() {
            if (this.$route.name == 'partnerCheckout') {
                this.$router.replace({name:'plans'})
            } else{
                let SSOLogin = JSON.parse(localStorage.getItem('SSOLogin')) ?? null
                window.location.replace(SSOLogin.failure)
            }
        }
    },
};
</script>
<style>
.modal {
    -webkit-user-select: none;
    /* Safari */
    -ms-user-select: none;
    /* IE 10 and IE 11 */
    user-select: none;
    /* Standard syntax */
}

.planPage .carousel__slide {
    align-items: start !important;
}
</style>